$(document).ready(function () {
	$(".site-header:not(.subMenu) .MobileNavController").click(function (e) {
		e.preventDefault();
		$(".site-header").toggleClass("activeMobileMenu");
		$(this).toggleClass("open");
		$("body").toggleClass("menuOpen");
		$(".site-header").toggleClass("firstMenuSlide");
	});

	if (window.matchMedia("(max-width: 992px)").matches) {
	    $(".appLogins ul li").clone().appendTo("ul#main_menu");
		//$(".appLogins").clone().appendTo(".mainMenu");
	//	$(".menuWrapper > .appLogins").remove();
	
		$(" li.menu-item-has-children").click(function (e) {
			
			$("li.menu-item-has-children").removeClass("menuLinkOpen");
			$(this).toggleClass("menuLinkOpen");
			if($(this).hasClass("menuLinkOpen")){
			$(".site-header").toggleClass("secondMenuSlide");
			$(".site-header").toggleClass("firstMenuSlide");
			};

		//	var menuOpenHeight = $('.menuOpen header.secondMenuSlide .mainMenu ul.menu>li.menu-item-has-children.menuLinkOpen>ul.sub-menu>li.lastMenuItem').height();

			//var subMenuHeight = $(window).height() - menuOpenHeight;
		  
			// var elementHeights = [];
			// var selectors = '.menuOpen header.secondMenuSlide .mainMenu ul.menu>li.menu-item-has-children.menuLinkOpen>ul.sub-menu>li.lastMenuItem, .menuOpen header.secondMenuSlide .mainMenu ul.menu>li.menu-item-has-children.menuLinkOpen>ul.sub-menu>li.referAndEarnMenu, .menuOpen header.secondMenuSlide .mainMenu ul.menu>li.menu-item-has-children.menuLinkOpen>ul.sub-menu>li.whatsNewMenu';
			
			// $(selectors).each(function() {
			//   var height = $(this).height();
			//   elementHeights.push(height);
			// });
		  
			// var parentSubMenu = $('.menuOpen header.secondMenuSlide .mainMenu ul.menu>li.menu-item-has-children.menuLinkOpen>ul.sub-menu').css('height', 'calc(100vh  - 80px - ' + elementHeights.join('px - ') + 'px)');
		  
			// console.log(elementHeights); // Output the height of the parent ul.sub-menu to the console
		  

		});

// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);


$(".widget_nav_menu  h3.widget-title").click(function() {
		
	$(this).next("div").slideToggle();
			$(this).toggleClass('active').siblings().removeClass('active');
  });

  $('li.wp-block-navigation-item.has-child, button.wp-block-navigation__submenu-icon').click(function() {
    var $button = $(this).closest('li').find('button.wp-block-navigation__submenu-icon');
    $button.attr('aria-expanded', function(_, attr) {
      return attr === 'false' ? 'true' : 'false';
    });
  });

		
	};

	//countdown from 0 to span value
	$('.countDownNumber').each(function () {
		$(this).prop('Counter',0).animate({
			Counter: $(this).text()
		}, {
			duration: 3000,
			easing: 'swing',
			step: function (now) {
				$(this).text(Math.ceil(now));
			}
		});
	});
// show images on hover 
const isHomePage = $('body').hasClass('home');
if(isHomePage) { 
const col1Items = document.querySelectorAll('.twoColGridHoverImage .iconGrid li.item');
const col2Items = document.querySelectorAll('.twoColGridHoverImage .imageGridToshow .item');

for (let i = 0; i < col1Items.length; i++) {
  col1Items[i].addEventListener('mouseover', function() {
    col1Items[i].classList.add('show');
    col2Items[i].classList.add('show');
    jQuery(this).siblings().removeClass('show');
    jQuery(col2Items[i]).siblings().removeClass('show');
  });
}

}

// js for popup view

const showPopupBtns = document.querySelectorAll(".showPopup");
const popupWrapper = document.querySelector(".popupWrapper");
const popupClose = document.querySelector(".popupClose");
const bodyScrollOff = document.querySelector('body');

if(popupWrapper){
// Function to show the popup
function showPopup() {
	
  popupWrapper.classList.add("show");
  bodyScrollOff.style.overflow = 'hidden';

}

// Function to hide the popup
function hidePopup() {
  popupWrapper.classList.remove("show");
  bodyScrollOff.style.overflow = 'auto';

}

// Add click event listeners to showPopupBtns
showPopupBtns.forEach(function(btn) {
  btn.addEventListener("click", showPopup);
});

// Add click event listener to popupClose
popupClose.addEventListener("click", hidePopup);

// Add click event listener to popupWrapper
popupWrapper.addEventListener("click", function(e) {
  if (e.target === popupWrapper) {
    hidePopup();
  }
});

$(".showPopup").click(function() {
			   return false;
});  

}
	const isBlogPages = $('body').hasClass('blog');
const isArchivePages = $('body').hasClass('archive');
const isSinglePages = $('body').hasClass('single-post');
const  isCustomerStorypage = $('body').hasClass('post-type-archive-case_study');
   if((isBlogPages || isArchivePages || isSinglePages) & !isCustomerStorypage ) {
// blog filter for mobile
const selectEl = document.querySelector('.mainBlogFilterButton .search');
const mobFilterEl = document.querySelector('.mobFilter');

const searchClone = selectEl.cloneNode(true); // true parameter to clone all child nodes
mobFilterEl.appendChild(searchClone);

// Get the necessary DOM elements
const toggleFilterBtn = document.querySelector('.toogleFilter');
const filterCloseBtn = document.querySelector('.filterClose');
const mobFilterWrapper = document.querySelector('.mobFilterWrapper');
const bodyScrollOff = document.querySelector('body');

// Add a click event listener to the toggle button
toggleFilterBtn.addEventListener('click', function() {
	mobFilterWrapper.classList.add('showFilter');
	bodyScrollOff.style.overflow = 'hidden';

});

// Add a click event listener to the close button
filterCloseBtn.addEventListener('click', function() {
	mobFilterWrapper.classList.remove('showFilter');
	bodyScrollOff.style.overflow = 'auto';

});

if (window.matchMedia("(min-width: 767px)").matches) {
/* postion ticky of sidebar image */
	const widgetArea = document.querySelector('#secondary.widget-area');
	const stickySidebar = document.querySelector('.widget-area .widget:last-child');
	const widgetAreaWidth = widgetArea.offsetWidth;
	const relatedBlogs = document.querySelector('.relatedBlogs');
  
	stickySidebar.style.width = widgetAreaWidth + 'px';
  
  
	window.addEventListener('scroll', () => {
	const relatedBlogs = document.querySelector('.col-md-7');
	const rect = relatedBlogs.getBoundingClientRect();
	const isElementBottomVisible = (rect.bottom - 150) >= window.innerHeight;
  
	if (isElementBottomVisible) {
	  stickySidebar.style.opacity = "1";
	} else {
	  stickySidebar.style.opacity = "0";
	}
  });
  
  
  const block20 = document.querySelector('.widget-area .widget:last-child');
  const sideBarSocialIcons = document.querySelector('.sideBarSocialIcons');
  function handleScroll() {
	const rect = block20.getBoundingClientRect();
	const rect2 = sideBarSocialIcons.getBoundingClientRect();
	if (rect.top < 0 && rect.bottom < 0) {
	  // .widget-area .widget:last-child is scrolled above and out of viewport
	  block20.classList.add('fixedImage');
	} else if ((rect.top > rect.x) || (rect2.top > -120) ) {
	  // .widget-area .widget:last-child is scrolled below and in view port or not scrolled at all
	  block20.classList.remove('fixedImage');
	}
  }
  
  window.addEventListener('scroll', handleScroll);
  
  /* end here */	
}

   }

	
	// if (window.matchMedia("(min-width: 768px)").matches) {
	var tabs = $(".tabsTitles li"); //grab tabs
	var contents = $(".tabsContent li"); //grab contents

	tabs.bind("click", function (e) {
		let tabLink = $(e.target); // current clicked tab
		let divContainer = `#${tabLink.closest("section").attr("id")}`; //grab current section

		$(divContainer).find(contents).hide(); //hide all contents
		$(divContainer).find(tabs).removeClass("current"); //remove 'current' classes
		$(divContainer).find(contents).removeClass('current');
		$(divContainer)
			.find(contents)
			.hide()
			.filter("[data-contentID=" + $(this).attr("data-tabID") + "]")
			.fadeIn()
			.addClass('current'); //show tab content that matches tab title index
		$(this).addClass("current"); //add current class on clicked tab title
	});
	// }

	//js for menu bar animation


	// js for sticky header
	const mainHeaderSr = document.querySelector(".site-header:not(.subMenu)");	
	const headerToSticky = document.querySelector(".site-header.subMenu");
	const submenuEnable = $('body').hasClass('submenuEnable');

	window.onscroll = function() {	 
		if(submenuEnable) { 
	if (window.matchMedia("(min-width: 991px)").matches) {
	 if (window.scrollY > 60) {
		 headerToSticky.classList.add("fixedTopHeading");
	 } else {
		 headerToSticky.classList.remove("fixedTopHeading");
	 }
   } else{
	 if (window.scrollY > 0) {
		 headerToSticky.classList.add("fixedTopHeading");
	 } else {
		 headerToSticky.classList.remove("fixedTopHeading");
	 }
   }
} else{
	if (window.matchMedia("(min-width: 991px)").matches) {
		if (window.scrollY > 60) {
			mainHeaderSr.classList.add("fixedTopHeading");
		} else {
			mainHeaderSr.classList.remove("fixedTopHeading");
		}
	  } else{
		if (window.scrollY > 0) {
			mainHeaderSr.classList.add("fixedTopHeading");
		} else {
			mainHeaderSr.classList.remove("fixedTopHeading");
		}
	  }
}
 };

	//define the js to work for specific width
	const mediaQuery = window.matchMedia("(min-width: 992px)");
	if (mediaQuery.matches) {
		//Adding Background box and arrow for the menu
		jQuery("header.site-header").append(
			'<div class="nav__bg-wrapper"> <div class="nav__bg"></div> <div class="nav_arrow" style=" "> </div> </div>'
		);

		// declaration of global variables for menu animation
		const navContainer = document.querySelector("ul#main_menu");
		const links = document.querySelectorAll(
			"ul#main_menu > li.bigMenu.menu-item-has-children"
		);
		const bgWrapper = document.querySelector(".nav__bg-wrapper");
		const bg = document.querySelector(".nav__bg");
		const navArrow = document.querySelector(".nav_arrow");
		const bgBCR = bg.getBoundingClientRect();

		// adding animation for bg box
		navContainer.addEventListener("mouseenter", () => {
			setTimeout(() => bg.classList.add("is-animatable"));
		});

		navContainer.addEventListener("mouseleave", () => {
			bg.classList.remove("is-animatable");
		});

		//adding animation and width for bg and arrow
		[].forEach.call(links, (link) => {
			//calling link on which user have hovered

			link.addEventListener("mouseover", function () {
				bgWrapper.classList.add("is-visible");

				// Variables declation for getting width and pos of elements

				const links = this.querySelector(
					"ul#main_menu > li:hover.bigMenu > ul.sub-menu"
				);
				var hoverLinkPos = $(link).offset().left;
				var clientWidth = $(link).width();
				const linksBCR = links.getBoundingClientRect();
				const scaleX = linksBCR.width / bgBCR.width;
				const scaleY = linksBCR.height / bgBCR.height;

				//Arrow Postion on mouse over for respective link
				navArrow.style.transform = `translateX(${
					hoverLinkPos + clientWidth / 2
				}px)`;

				// adding animation for to & for motion of sub menu
				setTimeout(() =>
					$("ul#main_menu > li.bigMenu > ul.sub-menu").css({
						"clip-path": "inset(0 10em 10em 15em)",
					})
				);
				setTimeout(() =>
					$("ul#main_menu > li:hover.bigMenu > ul.sub-menu").css({
						"clip-path": "inset(0 -10em -20em -20em)",
					})
				);
				//  adding animation for to & for motion of arrow
				setTimeout(() => (navArrow.style.transition = `all ease .3s`));
				// adding animation for to & for motion of bg box
				bg.style.transform = `translateX(${linksBCR.left}px) scale(${scaleX - 0.1}, ${scaleY - 0.1})`;
			});

			//calling link on which user have hovered out

			link.addEventListener("mouseleave", () => {
				setTimeout(() => {
					$("ul#main_menu > li.bigMenu > ul.sub-menu").removeAttr(
						"style"
					);
					$(
						"ul#main_menu > li:hover.bigMenu > ul.sub-menu"
					).removeAttr("style");
				});
				bgWrapper.classList.remove("is-visible");
			});
		});
	} // media query end's here

	$(".cardSliderWrap .cardSlider").slick({
		dots: false,
		infinite: false,
		slidesToShow: 3,
		slidesToScroll: 1,
		prevArrow: ".cardSliderWrap .leftArrow",
		nextArrow: ".cardSliderWrap .rightArrow",
		responsive: [{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
				},
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1.2,
					slidesToScroll: 1,
				},
			},
		],
	});

	$(".cardWrap").find(".frontSide").show();
	$(".cardWrap").find(".backSide").hide();

	$(".cardHandlerIcon").click(function (e) {
		e.preventDefault();
		$(this).parents(".cardWrap").toggleClass("flipped");
		if ($(this).parents(".cardWrap").hasClass("flipped")) {
			$(this).parents(".cardWrap").find(".frontSide").delay(900).hide(0);
			$(this).parents(".cardWrap").find(".backSide").delay(900).show(0);
		} else {
			$(this).parents(".cardWrap").find(".frontSide").delay(900).show(0);
			$(this).parents(".cardWrap").find(".backSide").delay(900).hide(0);
		}
	});

	if (window.matchMedia("(max-width: 767px)").matches) {
		$(".solidEnabled .contentBoxes").slick({
			dots: false,
			infinite: false,
			slidesToShow: 1.2,
			slidesToScroll: 1,
			arrows: false,
		});
	}

	$(".slider-nav").slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		asNavFor: ".slider-for",
		dots: false,
		arrows: false,
		focusOnSelect: true,
		// infinite: false,
		// draggable: false,
		// swipe: false,
		// touchMove: false
		responsive: [{
			breakpoint: 600,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 1,
			},
		}, ],
	});

	$(".slider-for").slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		arrows: false,
		// dots: false,
		asNavFor: ".slider-nav",
		infinite: false,
		// draggable: false,
		// swipe: false,
		// touchMove: false
		responsive: [{
			breakpoint: 600,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			},
		}, ],
	});

	$(
		".faq1 .schema-faq-section, .faq2 .schema-faq-section, .faq4 .schema-faq-section"
	).click(function () {
		if ($(this).find(".schema-faq-answer").css("display") !== "block") {
			$(
				".faq1 .schema-faq-answer, .faq2 .schema-faq-answer, .faq4 .schema-faq-answer"
			).slideUp();
			$(this).find(".schema-faq-answer").slideDown();
			$(this).addClass("active");
		}
		$(this).siblings().removeClass("active");
	});
	if (window.matchMedia("(min-width: 768px)").matches) {
		$(".rightTabsHeading li").click(function () {
			let headingID = $(this).data("tab-heading-id");
			if ($(`#${headingID}`).css("display") !== "block") {
				$(".rightTabsContent .content").slideUp();
				$(`#${headingID}`).slideDown();
				$(this).addClass("active");
			}
			$(this).siblings().removeClass("active");
		});
	}
	$(".iframe-link").magnificPopup({
		type: "iframe",
		mainClass: "mfp-with-zoom", // this class is for CSS animation below

		zoom: {
			enabled: true, // By default it's false, so don't forget to enable it
			duration: 300, // duration of the effect, in milliseconds
			easing: "ease-in-out",
		},
		removalDelay: 300,
	});

	$(".videoSix .videoSliderFive").slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		centerMode: true,
		centerPadding: "20%",
		dots: true,
		arrows: false,
		autoplay: true,
		autoplaySpeed: 5000,
		responsive: [{
			breakpoint: 600,
			settings: {
				centerMode: false,
			},
		}, ],
	});
	$(".videoSeven .videoSliderFive").slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		centerMode: true,
		dots: false,
		arrows: false,
		loop: false,
		centerPadding: "60px",
		speed: 0,
		responsive: [{
			breakpoint: 600,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				dots: true,
				centerMode: false,
				speed: 500,
			},
		}, ],
	});
	if (window.matchMedia("(min-width: 992px)").matches) {
		$(".videoSeven .videoSliderFive")
			.find(".slick-current")
			.prev()
			.css("transform", "translateX(200px) scale(1)");
		$(".videoSeven .videoSliderFive")
			.find(".slick-current")
			.next()
			.css("transform", "translateX(-200px) scale(1)");
		$(".videoSeven .videoSliderFive").on("afterChange", function () {
			$(this).find(".slick-slide").css("transform", "scale(0.7)");
			$(this).find(".slick-current").css("transform", "scale(1.5)");
			$(this)
				.find(".slick-current")
				.prev()
				.css("transform", "translateX(200px) scale(1)");
			$(this)
				.find(".slick-current")
				.next()
				.css("transform", "translateX(-200px) scale(1)");
		});
	}
	$(".videoEight .sliderFor").slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		fade: true,
		dots: false,
		asNavFor: ".videoEight .sliderNav",
	});
	$(".videoEight .sliderNav").slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		asNavFor: ".videoEight .sliderFor",
		dots: false,
		arrows: false,
		focusOnSelect: true,
		responsive: [{
			breakpoint: 600,
			settings: {
				slidesToShow: 1.3,
				slidesToScroll: 1,
			},
		}, ],
	});

	if (window.matchMedia("(max-width: 991px)").matches) {
		$('.blogCards').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: true,
			arrows: false
		});
	}

	if (window.matchMedia("(max-width: 767px)").matches) {
		//For Faq 4 Mobile view
		$(".rightTabsContent .content:first-child").addClass("active");

		$(".rightTabsHeading li").click(function () {
			let headingID = $(this).data("tab-heading-id");
			if (
				$(
					".rightTabsContent .content#" +
					`${headingID}` +
					".active div:first-child"
				).css("display") !== "block"
			) {
				console.log("true");
				$(".rightTabsContent .content#" + `${headingID}`).addClass(
					"active"
				);
				$(".rightTabsContent .content > div:first-child").slideUp();

				$(
					".rightTabsContent .content#" +
					`${headingID}` +
					".active > div:first-child"
				).slideDown();
			}
			$(".rightTabsContent .content#" + `${headingID}`)
				.siblings()
				.removeClass("active");
		});

		$(".rightTabsHeading ul li[data-tab-heading-id]").each(function () {
			var data = $(this).data("tab-heading-id");
			$(".rightTabsContent .content#" + `${data}`).append(this);
		}); // Ends Here Faq 4 Mobile view
	}


	var $caseStudyLogosGrid = $('.caseStudyLogos .logos').imagesLoaded(function () {
		$caseStudyLogosGrid.isotope({
			itemSelector: '.caseStudyLogo',
			layoutMode: 'fitRows',
            transitionDuration: 0
		});
	});
	$('.caseStudyLogos .button-group').each(function (i, buttonGroup) {
		var $buttonGroup = $(buttonGroup);
		$buttonGroup.on('click', 'button', function () {
			$buttonGroup.find('.is-checked').removeClass('is-checked');
			$(this).addClass('is-checked');
		});
	});
	$('.caseStudyLogos .button-group').find('button', function () {
		var filterValue = $(this).attr('data-filter');
		$caseStudyLogosGrid.isotope({
			filter: filterValue
		});
	});
	$('.caseStudyLogos .button-group').on('click', 'button', function () {
		var filterValue = $(this).attr('data-filter');
		$caseStudyLogosGrid.isotope({
			filter: filterValue
		});
	});

	// Product Slider Post Filter
	var $productBlogSliderPostsGrid = $('.productBlogSliderFilterContent .productBlogSliderPosts').imagesLoaded(function () {
		$productBlogSliderPostsGrid.isotope({
			itemSelector: '.productBlogSliderPost'
		});
	});
	$('.productBlogSliderFilterButton .button-group').each(function (i, buttonGroup) {
		var $buttonGroup = $(buttonGroup);
		$buttonGroup.on('click', 'button', function () {
			$buttonGroup.find('.is-checked').removeClass('is-checked');
			$(this).addClass('is-checked');
		});
	});
	$('.productBlogSliderFilterButton .button-group').find('button', function () {
		var filterValue = $(this).attr('data-filter');
		$productBlogSliderPostsGrid.isotope({
			filter: filterValue
		});
	});
	$('.productBlogSliderFilterButton .button-group').on('click', 'button', function () {
		var filterValue = $(this).attr('data-filter');
		$productBlogSliderPostsGrid.isotope({
			filter: filterValue
		});
	});

	$('.blogSliderWrapper').slick({
		infinite: false,
		slidesToShow: 3.2,
		slidesToScroll: 1,
		variableWidth: true,
		responsive: [{
			breakpoint: 600,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				dots: false,
				arrows: false,
				centerMode: false,
				speed: 500,
			},
			breakpoint: 991,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1,
				dots: true,
				arrows: false,
				centerMode: false,
				speed: 500,
			},
		}, ],
		// prevArrow: '.sliderArrowWrapper .leftArrow',
		// nextArrow: '.sliderArrowWrapper .rightArrow',
	});

	$('.shippingBlogSlider').slick({
		infinite: false,
		slidesToShow: 3.2,
		slidesToScroll: 1,
		variableWidth: true,
		 prevArrow: '.Shipping .sliderArrowWrapper .leftArrow',
		 nextArrow: '.Shipping .sliderArrowWrapper .rightArrow',
		 responsive: [{
			breakpoint: 600,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				dots: false,
				centerMode: false,
				speed: 500,
			},
		}, ],
	});

	$('.fulfilmentBlogSlider').slick({
		infinite: false,
		slidesToShow: 3.2,
		slidesToScroll: 1,
		variableWidth: true,
		 prevArrow: '.Srf .sliderArrowWrapper .leftArrow',
		 nextArrow: '.Srf .sliderArrowWrapper .rightArrow',
		 responsive: [{
			breakpoint: 600,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				dots: false,
				centerMode: false,
				speed: 500,
			},
		}, ],
	});

	$('.engageBlogSlider').slick({
		infinite: false,
		slidesToShow: 3.2,
		slidesToScroll: 1,
		variableWidth: true,
		 prevArrow: '.Sre .sliderArrowWrapper .leftArrow',
		 nextArrow: '.Sre .sliderArrowWrapper .rightArrow',
		 responsive: [{
			breakpoint: 600,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				dots: false,
				centerMode: false,
				speed: 500,
			},
		}, ],
	});

	$('.srxBlogSlider').slick({
		infinite: false,
		slidesToShow: 3.2,
		slidesToScroll: 1,
		variableWidth: true,
		 prevArrow: '.Srx .sliderArrowWrapper .leftArrow',
		 nextArrow: '.Srx .sliderArrowWrapper .rightArrow',
		 responsive: [{
			breakpoint: 600,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				dots: false,
				centerMode: false,
				speed: 500,
			},
		}, ],
	});

	// Product Slider Filter End

	var leftItem = $('.caseStudyBanner .leftCards'),
		rightItem = $('.caseStudyBanner .rightCards');

	let zoom = 1;
	const ZOOM_SPEED = 0.001;

	document.addEventListener("wheel", function (e) {
		// console.dir(e.pageY);
		if (e.deltaY > 0) {
			if (zoom < 1.25) {
				leftItem[0].style.transform = `scale(${zoom += ZOOM_SPEED})`;
				rightItem[0].style.transform = `scale(${zoom += ZOOM_SPEED})`;
			}
		} else {
			if (zoom > 1) {
				leftItem[0].style.transform = `scale(${zoom -= ZOOM_SPEED})`;
				rightItem[0].style.transform = `scale(${zoom -= ZOOM_SPEED})`;
			}
		}
	});

	$('.singleTestiBigSlider').slick({
		infinite: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		prevArrow: '.singleBigTestimonialSlider .leftArrow',
		nextArrow: '.singleBigTestimonialSlider .rightArrow',
		responsive: [{
			breakpoint: 600,
			settings: {
				
				dots: true,
			
			},
		}, ],
	});

	if (document.querySelector('.srxStepsScrollSection')) {
	  
	$(window).on('scroll resize', inViewport);
	function inViewport(){
		 $('.stepsWraper').each(function(){
			 var divPos = $(this).offset().top,
			 topOfWindow = $(window).scrollTop();
			 let scrollHeight = $(".scrollScrollerAndContent").height();
			let scrollerLastItem = $(".stepsContentWraper.lastItem").height();
			 let totalScrollHeight = divPos + scrollHeight - scrollerLastItem;
			 if( divPos < topOfWindow+80 ){
				 $('.aeroplaneScroller').addClass('fixedCounter');
				//  console.log("Scrolling");
			 }
			 if(( divPos > topOfWindow+80 ) || ( topOfWindow > totalScrollHeight-50 )){
				 $('.aeroplaneScroller').removeClass('fixedCounter');
			 }
	
		 });
		  
	 };
	
	const scrollItems = document.querySelector(".scrollScrollerAndContent");
	const flyingAeroplane = document.querySelector(".aeroplaneToScroll"); 
	let prevScrollPos = window.pageYOffset; // store previous scroll position

	const observer = new IntersectionObserver(function (entries) {
		 if (!entries[0].isIntersecting) {
				return;
	}	
		 window.addEventListener("scroll", function () {
				const scrollPos = window.pageYOffset;
				const docHeight = document.body.offsetHeight;
				const containerHeight = scrollItems.scrollHeight;
				// calculate the current height as a percentage of the scroll position
				let currentHeight = ((scrollPos - containerHeight) / containerHeight) * 100;
				
				currentHeight =  currentHeight + 100;
				// ensure that the current height is between 1 and 100
				 currentHeight = Math.min(Math.max(currentHeight, 1), 180);

				 // check scroll direction
				if (scrollPos > prevScrollPos) {
					// scrolled down, add style to rotate 0 degrees
					flyingAeroplane.style.transform = "rotate(0deg)";
				  } else {
					// scrolled up, add style to rotate 180 degrees
					flyingAeroplane.style.transform = "rotate(180deg)";
				  }
				 prevScrollPos = scrollPos; // update previous scroll position
				flyingAeroplane.style.top = currentHeight + "%";
			});
			observer.disconnect();
		}, {
			threshold: 0.01 // when element comes within 10% of viewport
		});
		observer.observe(scrollItems);	
	} ;

	if (window.matchMedia("(min-width: 992px)").matches) {
		// Step Four Animation
		var myElement = document.getElementById("stepFour");
		var stepCard = $(myElement).find(".step:nth-child(4)")[0];

		var boundingElement = myElement.getBoundingClientRect();
		let stepCardBounding = stepCard.getBoundingClientRect();
		if (boundingElement.top <= 0) {
			$(".stepFour .upperCotentWrapper").addClass("sticky");
		} else {
			$(".stepFour .upperCotentWrapper").removeClass("sticky");
		}

		if (stepCardBounding.top < 0) {
			$(".stepFour .upperCotentWrapper").removeClass("sticky");
			$(".stepFour .upperCotentWrapper").addClass("absolute");
		}

		$(window).scroll(function () {
			let bounding = myElement.getBoundingClientRect();
			let stepCardBounding = stepCard.getBoundingClientRect();

			if (bounding.top <= 0) {
				$(".stepFour .upperCotentWrapper").addClass("sticky");
				$(".stepFour .upperCotentWrapper").removeClass("absolute");
			}
			if (bounding.top > 0) {
				$(".stepFour .upperCotentWrapper").removeClass("sticky");
			}
			if (stepCardBounding.top < 0) {
				$(".stepFour .upperCotentWrapper").removeClass("sticky");
				$(".stepFour .upperCotentWrapper").addClass("absolute");
			}
		});
		// Step Four Animation

		// Scroll Animation

		gsap.defaults({
			overwrite: "auto",
		});

		gsap.set(".left-content > *", {
			xPercent: -50,
			yPercent: -50,
		});

		// Set up our scroll trigger
		const ST = ScrollTrigger.create({
			trigger: ".content-container",
			start: "top top",
			end: "bottom bottom",
			onUpdate: getCurrentSection,
			pin: ".left-content",
		});

		const contentMarkers = gsap.utils.toArray(".contentMarker");

		// Set up our content behaviors
		contentMarkers.forEach((marker) => {
			marker.content = document.querySelector(
				`#${marker.dataset.markerContent}`
			);

			if (marker.content.tagName === "IMG") {
				gsap.set(marker.content, {
					transformOrigin: "center",
				});

				marker.content.enter = function () {
					gsap.fromTo(
						marker.content, {
							autoAlpha: 0,
							rotateY: -30,
						}, {
							duration: 0.3,
							autoAlpha: 1,
							rotateY: 0,
						}
					);
				};
			} else if (marker.content.tagName === "BLOCKQUOTE") {
				gsap.set(marker.content, {
					transformOrigin: "left center",
				});

				marker.content.enter = function () {
					gsap.fromTo(
						marker.content, {
							autoAlpha: 0,
							rotateY: 50,
						}, {
							duration: 0.3,
							autoAlpha: 1,
							rotateY: 0,
						}
					);
				};
			}

			marker.content.leave = function () {
				gsap.to(marker.content, {
					duration: 0.1,
					autoAlpha: 0,
				});
			};
		});

		// Handle the updated position
		let lastContent;

		function getCurrentSection() {
			let newContent;
			const currScroll = scrollY;

			// Find the current section
			contentMarkers.forEach((marker) => {
				if (currScroll > marker.offsetTop) {
					newContent = marker.content;
					// marker.addClass('');
				}
			});

			// If the current section is different than that last, animate in
			if (
				newContent &&
				(lastContent == null || !newContent.isSameNode(lastContent))
			) {
				// Fade out last section
				if (lastContent) {
					lastContent.leave();
				}

				// Animate in new section
				newContent.enter();

				lastContent = newContent;
			}
		}

		const media = window.matchMedia("screen and (max-width: 600px)");
		ScrollTrigger.addEventListener("refreshInit", checkSTState);
		checkSTState();

		function checkSTState() {
			if (media.matches) {
				ST.disable();
			} else {
				ST.enable();
			}
		}
	}
	// End Scroll Animation
}); // Document ready end's here
